import React, { Component } from 'react';
import ChatRow from './ChatRow'
import { auth } from '../services/firebase';
import { db } from '../services/firebase';

export default class ChatRequest extends Component {
	constructor(props) {
		super(props)
		this.state = {
			user: auth().currentUser,
            requests: {},
			readError: null,
			writeError: null,
            loadingRequests: false,
            isAuthorized: false,
		};
        this.createUpdateChatRequest = this.createUpdateChatRequest.bind(this)
        this.myRef = React.createRef();
	}

	async componentDidMount() {
		this.setState({ readError: null, loadingRequests: true });

		try {
            // Get all pending chat requests
            await db.ref('chat-requests').child("mentalhealth").on('value', (snapshot) => {
                this.setState({
                    requests: snapshot.val(),
                    loadingRequests: false,
                });
            });
        } catch (error) {
            this.setState({ readError: error.message, loadingRequests: false });
        }

        this.validateAuthorization()
	}

    validateAuthorization() {
        db.ref('admin').child('user-roles').child(this.state.user.uid).get().then((snapshot) => {
            if (snapshot.exists()) {
                this.setState({ isAuthorized: true })
            }
        })
    }

    formatTime(timestamp) {
        const d = new Date(timestamp * 1000);
        const time = `${d.getHours()}:${d.getMinutes()} ${(d.getMonth()+1)}/${d.getDate()}`;
        return time
    }

    // Creates the updateChatRequest function with the requestId and userId embedded.
    createUpdateChatRequest(requestId, chatId, userId) {
        return () => {
            let chatRequestRef = db.ref('chat-requests').child("mentalhealth").child(requestId)
            let chatRef = db.ref('chats').child(chatId)

            chatRequestRef.get().then((snapshot) => {
                if (snapshot.val()["status"] === "pending") {
                    chatRequestRef.update({
                        assignedTo: userId,
                        status: "assigned",
                    });
                }

                // add current user to chat members
                chatRef.child('members').update({
                    [this.state.user.uid]: true,
                    isActive: true,
                });

                // update user-chats for each member
                chatRef.child('members').get().then((snapshot) => {
                    let memberIds = Object.keys(snapshot.val())

                    for (let memberId of memberIds) {
                        db.ref('user-chats').child(memberId).set({
                            [chatId]: true
                        })
                    }
                });
            });
        }
    }

    chatRow(request) {
        let handleClick = this.createUpdateChatRequest(request.id, request.chatId, this.state.user.uid)

        return (
            <div key={request.chatId} className='list-group-item'>
                <ChatRow
                    chatId={request.chatId}
                    userId={request.userId}
                    onClick={handleClick}
                />
            </div>
        )
    }

    render() {
        if (this.state.isAuthorized === false) {
            return ""
        }

        let requests = []

        for (let requestId in this.state.requests) {
            let request = this.state.requests[requestId]

            if (request.userId === this.state.uid) {
                continue
            }

            if (request.status !== 'pending') {
                continue
            }

            request.id = requestId
            requests.push(request)
        }

        return (
                <div ref={this.myRef}>
                    <h4>Chat Requests</h4>
                    {/* loading indicator */}
                    {this.state.loadingChats ? (
                        <div className='spinner-border text-success' role='status'>
                            <span className='sr-only'>Loading</span>
                        </div>
                    ) : "" }
                    {/* chat request area */}
                    <div className='list-group'>
                        {requests.map(request => {
                            return this.chatRow(request)
                        })}
                    </div>
                </div>
        );
    }
}
